module.exports = __webpack_public_path__ + "static/media/image_6.ff84540c.png";